import React, { useEffect, useState } from 'react';
import { Drawer } from 'antd';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { DrawerSchema, initialDrawerState } from 'schemas';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import styles from './drawer.module.css'
import { nearMissForm } from 'constants/forms/newNearMissForm';
import formStyles from '../../layouts/newNearMiss/newNearMiss.module.css'
import { Button, CircularProgress, IconButton, Paper, Stack } from '@mui/material';
import { Collapse } from 'antd';
import RegrasdeOuro from './regrasDeOuro';
import Comments from './comentarios';
import RulesAssigner from './assignRules';
import { FileExcelOutlined } from '@ant-design/icons';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import EditIcon from '@mui/icons-material/Edit';
import DatePickerComponent from 'components/fields/date/datePicker';
import CloseIcon from '@mui/icons-material/Close';
import { getOptionLabel } from 'utils/common/getOptionLabel';
import { getBubblesValues } from 'utils/common/getBubblesValues';
import { GeneralFetch } from 'Api/generalFetch/generalFetch';
import { estados } from 'constants/common/formConstants';
import LegendToggleIcon from '@mui/icons-material/LegendToggle';
import Dialog from 'components/modal/modals';
import StarIcon from '@mui/icons-material/Star';
import CustomTooltip from 'components/toolTip/tooltip';
import { useGetBest } from 'hooks/best/useGetBestNearMiss';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import ExcelEditor from 'utils/exporter/excel/singleExporter';
import AcidenteEditor from 'utils/exporter/excel/singleAcidenteExporter';
import { Confirmation } from 'schemas';
import { RefetchData } from 'schemas';
import { format } from 'date-fns';
import { getTotals } from 'utils/common/getTotals';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import { userData } from 'schemas';
import { getUsers } from 'hooks/users/getUsers';
import { useParams } from 'hooks/common/useQueryParams';
import { locais } from 'schemas';
import DrawerActions from './DrawerActions';
import { useDrawerPermissions } from './hooks/useDrawerPermissions';

const DrawerComponent = () => {
    const [open, setOpen] = useRecoilState(DrawerSchema)
    const [activeView, setActiveView] = useState("details")
    const [enableUpdate, setEnableUpdate] = useState(false)
    const [edit, setEdit] = useState(false)
    const [refetch, setRefetch] = useState(false)
    const [openModal, setOpenModal] = useState(false)
    const [details, setDetails] = useState('')
    const [loadingUpdate, setLoad] = useState(null)
    const [bestNearMiss, setBest] = useState(false)
    const { fetchData, loading } = GeneralFetch()
    const color = estados?.find(x => x.value === open?.data?.estado)?.colorHEx
    const estado = estados?.find(x => x.value === open?.data?.estado)?.label
    const txtColor = open?.data?.estado === '1' ? "dark" : "white"
    const { getBestNearMiss, loading: loadingGetBNM, theBest } = useGetBest()
    const { handleEditColumns } = ExcelEditor()
    const { handleEditAcidentColumns } = AcidenteEditor()
    const [openConfirm, setOpenConfirm] = useRecoilState(Confirmation)
    const setRefetchData = useSetRecoilState(RefetchData)
    const refetchTable = useSetRecoilState(RefetchData)
    const user = useRecoilValue(userData)
    const { users, loading: loadingUsers } = getUsers()
    const { urlParamiters: urlParameters, remove } = useParams()
    const { id } = urlParameters()
    const locations = useRecoilValue(locais)
    const permissions = useDrawerPermissions(open, user)

    useEffect(() => {
        if (open?.open && open?.object === 'nearmisses') getBestNearMiss(open?.data?.objectId)
    }, [open?.open, refetch])

    const onClose = () => {
        if (id) remove('id')
        setDetails("")
        setEdit(false)
        setActiveView("details")
        setOpen(initialDrawerState)
    };

    const updateRules = async () => {
        await fetchData({ id: open?.data?.objectId, regrasDeOuro: open?.pendingRules }, 'updateGoldenRules', 'put', 'updateGoldenRules')
        setEnableUpdate(false)
        setActiveView("details")
    }

    useEffect(() => {
        if (openConfirm.confirmed === true && (openConfirm?.component === 'unfavorite' || openConfirm?.component === 'delete' || openConfirm?.component === 'updateFecho')) {
            const obj = {
                endpoint: openConfirm?.component === 'unfavorite' ? `deleteBest/${open?.data?.objectId}` : openConfirm?.component === 'delete' ? 'deleteObject' : "updateDataFecho",
                load: openConfirm?.component === 'unfavorite' ? '1' : openConfirm?.component === 'delete' ? '4' : "5",
                body: openConfirm?.component === 'unfavorite' ? {} : openConfirm?.component === 'delete' ? { object: open?.object, object_id: open?.data?.objectId } : { object: open?.object === 'nearmisses' ? 'near_miss' : "incidente", object_id: open?.data?.objectId, data_fecho: details },
                method: openConfirm?.component === 'unfavorite' ? 'delete' : 'put'
            }

            setLoad(obj.load)
            fetchData({ ...obj.body }, obj.endpoint, obj.method, 'best',)
                .then(() => {
                    setLoad(null)
                    setRefetch(current => !current)
                    refetchTable(prev => (!prev))
                    if (openConfirm?.component !== 'unfavorite') {
                        setOpen(initialDrawerState)
                        setRefetchData(current => !current)
                    }
                })
                .finally(() => setOpenConfirm({ component: "", open: false, msg: "" }))
        }
    }, [openConfirm.confirmed])

    const onClickBest = () => {
        if (theBest?.label === null || theBest?.label === undefined) {
            setOpenModal(true)
            setBest(true)
        } else setOpenConfirm({ component: "unfavorite", open: true, msg: "Tem certeza que deseja remover dos favoritos?" })
    }

    return (
        <Drawer
            style={{ borderRadius: "5px", overflow: "hidden" }}
            maskClosable={false}
            zIndex={10000}
            width={'100vw'}
            placement="right"
            closable={true}
            onClose={onClose}
            open={open?.open}
            extra={<DrawerActions
                activeView={activeView}
                canClose={permissions.canClose}
                canDelete={permissions.canDelete}
                enableRulesUpdate={enableUpdate}
                hasData={Boolean(open?.data && Object.keys(open.data).length)}
                loadingAction={loadingUpdate}
                onBack={() => setActiveView("details")}
                onCloseRecord={() => { setOpenModal(true); setDetails({ titulo: ' ao fecho:', estado: "3" }) }}
                onDelete={() => setOpenConfirm({ component: "delete", open: true, msg: "Tem certeza que deseja eliminar este registo?" })}
                onMarkNotApplicable={() => { setOpenModal(true); setDetails({ titulo: ' à não aplicabilidade:', estado: "2" }) }}
                onSaveRules={updateRules}
            />}
        >
            <Dialog refetch={refetch} setRefetch={setRefetch} setBest={setBest} bestNearMiss={bestNearMiss} setLoad={setLoad} open={openModal} setOpen={setOpenModal} details={details} other={open} />
            <Collapse
                ghost
                activeKey={activeView === "rules" ? "2" : "1"}
                items={[
                    {
                        key: "1",
                        children: <div className={styles.container} >
                            <div className={styles.details} >
                                <MDBox
                                    mx={2}
                                    mt={-3}
                                    py={0}
                                    px={0}
                                    variant="gradient"
                                    bgColor="success"
                                    borderRadius="lg"
                                    coloredShadow="dark"
                                    style={{ background: color, margin: "-10px 0 0 -10px" }}
                                >
                                    <div style={{ display: "flex", width: "100%", justifyContent: "space-between", padding: "10px 10px" }} >
                                        <MDTypography variant="h6" color={txtColor} >
                                            {
                                                open?.object === 'boaspraticas' ? "Detalhes da boa prática" :
                                                    open?.object === 'nearmisses' ? 'Detalhes do near miss' :
                                                        open?.object === 'condicaoInsegura' ? 'Detalhes da condição insegura' :
                                                            open?.object === 'actoInseguro' ? 'Detalhes do acto inseguro' :
                                                                "Detalhes do incidente"
                                            }
                                        </MDTypography>

                                        <div style={{ display: "flex" }} >
                                            {permissions.canFeature && <CustomTooltip child={
                                                <IconButton onClick={() => onClickBest()} style={{ background: "#fff", margin: "-5px 15px -5px 0" }} >
                                                    {(loadingUpdate === '1' || loadingGetBNM) ? <CircularProgress size={"25px"} style={{ color: "blue" }} /> : theBest?.label !== null ? <StarIcon style={{ color: "orange" }} /> : <StarBorderIcon />}
                                                </IconButton>
                                            }
                                                title={theBest?.label ?? 'Atribuir best near miss'}
                                            />}

                                            {permissions.canExport && <Button
                                                onClick={async () => {
                                                    if (open?.object === 'nearmisses') await handleEditColumns(open?.data, users)
                                                    else await handleEditAcidentColumns(open?.data, users)
                                                }}
                                                size='small'
                                                variant="contained"
                                                style={{ margin: "-5px", color: "#000", background: "#fff", height: "40px" }}
                                                startIcon={<FileExcelOutlined />}
                                            >
                                                Exportar Excel
                                            </Button>}
                                        </div>
                                    </div>
                                </MDBox>

                                <Paper className={styles.formContainer} >
                                    <div className={formStyles.itemNoFlexLabels} >
                                        <div className={styles.label} >
                                            <MDTypography style={{ fontSize: "14px" }} variant="h6" color="dark">
                                                <LegendToggleIcon style={{ marginTop: "-5px", height: "30px", width: "20px", color: "#7392B7" }} />  Estado:
                                            </MDTypography>
                                        </div>
                                        <div style={{ background: color, color: txtColor === 'dark' ? "#000" : "#fff", borderRadius: "5px", height: "30px", maxWidth: "130px" }} >
                                            <h6 style={{ margin: "5px 0 -5px 5px", fontWeight: "600", fontSize: "15px" }} >{estado}</h6>
                                        </div>
                                    </div>

                                    {open?.data?.estado !== '1' && <div className={formStyles.itemNoFlexLabels} style={{ marginTop: "-30px" }} >
                                        <div className={styles.label} >
                                            <MDTypography style={{ fontSize: "14px" }} variant="h6" color="dark">
                                                <TextSnippetIcon style={{ marginTop: "-5px", height: "30px", width: "20px", color: "#7392B7" }} />  Obs de fecho/NA:
                                            </MDTypography>
                                        </div>
                                        <div style={{ background: color, color: txtColor === 'dark' ? "#000" : "#fff", borderRadius: "5px", paddingBottom: "7px" }} >
                                            <h6 style={{ margin: "5px 0 -5px 5px", fontWeight: "600", fontSize: "15px" }} >{open?.data?.obs && open.data.obs !== "undefined" ? open.data.obs : 'Sem observações.'}</h6>
                                        </div>
                                    </div>}

                                    {(theBest !== null && !loadingGetBNM) && <div className={formStyles.itemNoFlexLabels} style={{ marginTop: "-30px" }} >
                                        <div className={styles.label} >
                                            <MDTypography style={{ fontSize: "14px" }} variant="h6" color="dark">
                                                <StarBorderIcon style={{ marginTop: "-5px", height: "30px", width: "20px", color: "#7392B7" }} />  Obs de best near miss:
                                            </MDTypography>
                                        </div>
                                        <div style={{ background: "#FFA500", color: "#000", borderRadius: "5px" }} >
                                            <h6 style={{ margin: "5px 0 -5px 5px", fontWeight: "600", fontSize: "15px" }} >{theBest?.obs ?? 'Sem observações!'}</h6>
                                        </div>
                                    </div>}

                                    {
                                        open?.object && (open?.object === 'acidente' ? newAcidenteForm : nearMissForm)(users, false, locations)?.map((field) => {
                                            const { label } = field

                                            switch (field.type) {
                                                case "table":
                                                    const totals = getTotals(open?.data)

                                                    return (
                                                        <div className={field.flex ? formStyles.itemFlexLabels : formStyles.itemNoFlexLabels} >
                                                            <div className={styles.label} >
                                                                <MDTypography style={{ fontSize: "14px" }} variant="h6" color="info">
                                                                    {field.icon}   {field.title}
                                                                </MDTypography>
                                                            </div>
                                                            <div style={{ width: field.flex ? "70%" : "85%" }} >
                                                                <table>
                                                                    <thead>
                                                                        {
                                                                        ["", ...field.cols].map((head, index) => <th key={`${field.fieldId || field.title}-head-${index}`} className={formStyles.categorias} >{head.label}</th>)
                                                                        }
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            field.rows.map((row) => {
                                                                                return (
                                                                                    <tr key={`${field.fieldId || field.title}-${row.id}`}>
                                                                                        <td className={formStyles.categorias} >{row.label}</td>
                                                                                        {
                                                                                            field.cols.map((input) => {
                                                                                                return (
                                                                                                    <td key={`${row.id}-${input.id}`} style={{ padding: "3px" }}  >
                                                                                                        {open?.data?.[`${row.id}_${input.id}`] ?? totals?.[`${row.id}_${input.id}`] ?? 0}
                                                                                                    </td>
                                                                                                )
                                                                                            })
                                                                                        }
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    )

                                                case "inputGroup":
                                                    return <div>
                                                        {
                                                            field.groups.map((group) => {
                                                                return (
                                                                    <React.Fragment key={`${field.fieldId || field.label}-${group.title}`}>
                                                                        <div className={styles.label} style={{ marginBottom: "30px" }} >
                                                                            <MDTypography style={{ fontSize: "14px" }} variant="h6" color="info">
                                                                                {field.icon} {group.title}
                                                                            </MDTypography>
                                                                        </div>
                                                                        <div style={{ marginTop: "-20px", marginLeft: "10px" }}>
                                                                            {
                                                                                group.fields.map((field) => {
                                                                                    const { label, ...other } = field
                                                                                    return (
                                                                                                <div key={other.fieldId || label} className={formStyles.itemNoFlexLabels} >
                                                                                            <div className={styles.label} >
                                                                                                <MDTypography style={{ fontSize: "14px" }} variant="h6" color="dark">
                                                                                                    {label}
                                                                                                </MDTypography>
                                                                                            </div>
                                                                                            <div >
                                                                                                {open?.data?.[other?.fieldId]}
                                                                                            </div>
                                                                                        </div>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </div>
                                                                    </React.Fragment>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                case 'bubles':
                                                    return (
                                                        <div style={{ marginTop: "0px" }}>
                                                            {
                                                                field.sections.map((bubleSection) => {
                                                                    return (
                                                                        <div key={bubleSection.description} className={formStyles.bublesLabels} >
                                                                            <div className={styles.label} >
                                                                                <MDTypography style={{ fontSize: "14px" }} variant="h6" color="dark">
                                                                                    {bubleSection.icon} {bubleSection.description}
                                                                                </MDTypography>
                                                                            </div>

                                                                            <Stack direction="row" spacing={1} className={styles.values} >
                                                                                {getBubblesValues(bubleSection.bubles, open?.data?.[field.fieldId])}
                                                                            </Stack>
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                    )
                                                default:
                                                    return (
                                                        <div className={field.flex ? formStyles.itemFlexLabels : formStyles.itemNoFlexLabels} style={{ marginBottom: "0" }} >
                                                            <div className={styles.label} >
                                                                <MDTypography style={{ fontSize: "14px" }} variant="h6" color="dark">
                                                                    {field.icon} {label}
                                                                </MDTypography>
                                                            </div>
                                                            <div >
                                                                <span className={styles.values} >
                                                                    {
                                                                        (field?.fieldId === 'dataAcontecimento' && open?.data.dataAcontecimento) ? format(new Date(open?.data.dataAcontecimento), 'yyyy-MM-dd') :
                                                                            field?.options ? getOptionLabel(field?.options, open?.data?.[field.fieldId]) :
                                                                                open?.data?.[field.fieldId]
                                                                    }
                                                                </span>
                                                                {
                                                                    !!(field.colapse && open?.data?.[field.fieldId] === 1) && (
                                                                        <div style={{ marginTop: "20px", marginLeft: "20px" }} >
                                                                            <div style={{ marginBottom: "10px" }} >
                                                                                <MDTypography style={{ fontSize: "14px" }} variant="h6" color="dark">
                                                                                    {field.colapseInput.icon} {field.colapseInput.label}
                                                                                </MDTypography>
                                                                            </div>
                                                                            <h4 style={{ fontSize: "14px" }} >{format(new Date(open?.data?.[`${field.fieldId}_data`]), 'yyyy-MM-dd')}                                                                            </h4>
                                                                        </div>
                                                                    )
                                                                }
                                                            </div>
                                                        </div>
                                                    )
                                            }

                                        })
                                    }
                                    <div className={formStyles.itemNoFlexLabels} >
                                        <div className={styles.label} >
                                            <MDTypography style={{ fontSize: "14px" }} variant="h6" color="dark">
                                                <EventAvailableIcon style={{ marginTop: "-5px", height: "30px", width: "20px", color: "#7392B7" }} /> Data de fecho
                                            </MDTypography>
                                        </div>
                                        <div style={{ display: "flex" }}>
                                            {
                                                edit ? <DatePickerComponent
                                                    value={format(open?.data?.dataFecho ? new Date(open?.data?.dataFecho) : new Date(), 'yyyy-MM-dd')}
                                                    height={"10px"} onChange={(_, date) => {
                                                        const newDate = format(new Date(date), 'yyyy-MM-dd')
                                                        setDetails(newDate)
                                                        setEdit(!edit)
                                                        setOpenConfirm({ component: "updateFecho", open: true, msg: "Tem certeza que deseja alterar a data de fecho para " + newDate + "? " })
                                                    }} /> :
                                                    <span className={styles.values}  >{open?.data?.dataFecho ? format(new Date(open?.data?.dataFecho), 'yyyy-MM-dd') : "- -"}</span>}

                                            {permissions.canEdit && open?.data?.estado === '1' && <IconButton aria-label={edit ? "Cancelar alteração da data de fecho" : "Alterar data de fecho"} onClick={() => setEdit(!edit)} style={{ borderRadius: "0", marginTop: edit ? "-10px" : "-13px", }} >
                                                <span style={{ fontSize: edit ? "16px" : "15px", fontWeight: "500", cursor: "pointer", color: edit ? "#FF5A5F" : "#284B63" }}  >
                                                    {loadingUpdate === '5' ? <CircularProgress size={"25px"} style={{ color: "blue" }} /> :
                                                        edit ?
                                                            <><CloseIcon /> Cancelar</>
                                                            : <> <EditIcon /> Actualizar</>
                                                    }
                                                </span>
                                            </IconButton>}
                                        </div>
                                    </div>
                                </Paper>
                            </div>
                            <RegrasdeOuro txtColor={txtColor} color={color} open={open} canUpload={permissions.canUpload} />
                            <Comments txtColor={txtColor} color={color} />
                        </div >
                    },
                    {
                        key: "2",
                        children: <RulesAssigner loading={!!(loading || loadingUsers)} setEnableUpdate={setEnableUpdate} />
                    }
                ]}
            />
        </Drawer >
    );
};
export default DrawerComponent;
